import { useEffect, useRef } from 'react';
import { io, Socket } from 'socket.io-client';
import { getToken } from '../../../services/otpAuthService';

const SOCKET_URL = process.env.REACT_APP_API_URL
  ? process.env.REACT_APP_API_URL.replace('/graphql', '').replace('/api', '')
  : 'http://localhost:5000';

export function useCommunitySocket(
  areaSlug: string | undefined,
  onNewReply: (discussionId: string, reply: any) => void,
  onReactionUpdate: (discussionId: string, reactions: any[]) => void
) {
  const socketRef = useRef<Socket | null>(null);
  const onNewReplyRef = useRef(onNewReply);
  const onReactionUpdateRef = useRef(onReactionUpdate);
  onNewReplyRef.current = onNewReply;
  onReactionUpdateRef.current = onReactionUpdate;

  useEffect(() => {
    if (!areaSlug) return;

    const token = getToken();
    if (!token) return;

    const socket = io(`${SOCKET_URL}/community-v2`, {
      auth: { token },
      transports: ['websocket', 'polling']
    });
    socketRef.current = socket;

    socket.on('connect', () => {
      socket.emit('join_area', { slug: areaSlug });
    });

    socket.on('new_reply', (data: { discussionId: string; reply: any }) => {
      onNewReplyRef.current(data.discussionId, { reactions: [], attachments: [], mentions: [], ...data.reply });
    });

    socket.on('reaction_update', (data: { discussionId: string; reactions: any[] }) => {
      onReactionUpdateRef.current(data.discussionId, data.reactions);
    });

    return () => {
      socket.emit('leave_area', { slug: areaSlug });
      socket.disconnect();
      socketRef.current = null;
    };
  }, [areaSlug]);
}
